module.exports = __webpack_public_path__ + "static/media/Mobile_Data_STORYTELLING_E_UX_PARA_NEGOCIOS-13.c3436ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Storytelling/Mobile_Data_STORYTELLING_E_UX_PARA_NEGOCIOS-13.png
// module id = 70
// module chunks = 0